// Phường Thị `affairs.market` (UI_SPEC §18.5), P0: sạp mua / bán nguyên liệu cơ bản, giá cố định.
// Số chính là ví Linh Thạch trên topbar; màn không có số riêng.
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { openWindow } from '@state/modules/ui';

export function MarketScreen(): JSX.Element {
  return (
    <>
      <div class="ht-caption" data-id="caption">
        <b>{t('ui.market.caption')}</b>
        <span>{t('ui.market.sub')}</span>
      </div>
      <div class="cult-points">
        <button
          type="button"
          class="cult-point"
          data-id="market-buy"
          style={{ left: '130px', top: '330px' }}
          onClick={() => openWindow({ kind: 'market', mode: 'buy' })}
        >
          <i />
          <span>{t('ui.market.buyStall')}</span>
        </button>
        <button
          type="button"
          class="cult-point"
          data-id="market-sell"
          style={{ left: '270px', top: '420px' }}
          onClick={() => openWindow({ kind: 'market', mode: 'sell' })}
        >
          <i />
          <span>{t('ui.market.sellStall')}</span>
        </button>
      </div>
    </>
  );
}
